module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relatorio"
  }, [_c('div', {
    staticClass: "r-header hidden-print"
  }, [_c('div', {
    staticClass: "header1"
  }, [_c('h1', [_vm._v("Relatórios Arrematantes\n      ")]), _vm._v(" "), _c('router-link', {
    staticClass: "exit",
    attrs: {
      "to": {
        name: 'arrematantes'
      }
    }
  }, [_vm._v("Sair do modo relatório")])], 1), _vm._v(" "), _c('div', {
    staticClass: "header2 hidden-print"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r-buttons"
  }, [_c('u-button', {
    staticClass: "btn-info2",
    on: {
      "click": _vm.print
    }
  }, [_c('i', {
    staticClass: "fa fa-print m-r-xs"
  }), _vm._v(" Imprimir")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "r-content"
  }, [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "r-options",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    attrs: {
      "role": "presentation"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac63795","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/arematantes/components/Relatorios.vue
// module id = 775
// module chunks = 2